import React from "react";
import S from "gui/Components/ScreenToolbar/ScreenToolbarPusher.module.scss";

export class ScreenToolbarPusher extends React.Component {
  render() {
    return <div className={S.root} />;
  }
}
